export const KEYBOARD_KEYS = {
	BACKSPACE: 'Backspace',
	DELETE: 'Delete',
	ARROW_LEFT: 'ArrowLeft',
	ARROW_RIGHT: 'ArrowRight',
};

export const SMS_ERROR_CODES = {
	WRONG_CODE: 'Введен неверный SMS код. Попробуйте снова',
};
